"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAgencyParamTracker = void 0;
const react_1 = require("react");
const cookie = __importStar(require("cookie"));
const agency_param_tracker_helper_1 = require("./agency-param-tracker-helper");
const useAgencyParamTracker = () => {
    (0, react_1.useEffect)(() => {
        const { href } = window.location;
        const { cookie: cookies } = document;
        const url = new URL(href);
        const { searchParams } = url;
        // Retrieve `A` and `Theme` parameters from URL or fallback to cookies
        const affiliateParam = searchParams.get('A') ||
            searchParams.get('a') ||
            cookie.parse(cookies)['Drupal.visitor.novasol_partner_id'];
        const themeParam = searchParams.get('Theme') ||
            searchParams.get('theme') ||
            cookie.parse(cookies).myPartnerCookie;
        // Persist `A` parameter
        if (affiliateParam) {
            if (!(0, agency_param_tracker_helper_1.isParamPersistedInLocalStorage)('A')) {
                (0, agency_param_tracker_helper_1.persistParamInLocalStorage)('A', affiliateParam);
            }
            if (!(0, agency_param_tracker_helper_1.isParamPersistedInCookies)('A')) {
                (0, agency_param_tracker_helper_1.persistParamInCookies)('A', affiliateParam);
            }
        }
        // Persist `Theme` parameter
        if (themeParam) {
            if (!(0, agency_param_tracker_helper_1.isParamPersistedInLocalStorage)('Theme')) {
                (0, agency_param_tracker_helper_1.persistParamInLocalStorage)('Theme', themeParam);
            }
            if (!(0, agency_param_tracker_helper_1.isParamPersistedInCookies)('Theme')) {
                (0, agency_param_tracker_helper_1.persistParamInCookies)('Theme', themeParam);
            }
        }
    }, []);
};
exports.useAgencyParamTracker = useAgencyParamTracker;
//# sourceMappingURL=use-agency-param-tracker.js.map